import { areReviewMocksAllowed } from '../../../utils/requestConfig';
import { ReachOutPanelData } from '../reachOutPanel';

// TODO: delete this file once the profile page passes real sender and organization data.

/** URL parameter that picks a fixture while reviewing the design, e.g. ?reachOutMock=missing */
export const REACH_OUT_MOCK_PARAM = 'reachOutMock';

const REACH_OUT_FIXTURES: Record<string, ReachOutPanelData> = {
  default: {
    sender: {
      fullName: 'Jordan Rivera',
      email: 'jrivera@example.com',
      city: 'Seattle',
      teamName: 'Community Engagement',
    },
    organizationName: 'Food & Shelter Alliance',
    website: 'example.org',
  },
  // Nothing known: every placeholder shows, and the banner has no website to link to.
  missing: { sender: {} },
};

/** Mock data must never reach beta or prod, even if the flag is turned on there by mistake. */
export const areReachOutMocksAllowed = areReviewMocksAllowed;

/** The named fixture, or the default one when the name is missing or unknown. */
export function getReachOutMock(name: string | null): ReachOutPanelData {
  return name && Object.prototype.hasOwnProperty.call(REACH_OUT_FIXTURES, name)
    ? REACH_OUT_FIXTURES[name]
    : REACH_OUT_FIXTURES.default;
}
